// extracted by mini-css-extract-plugin
module.exports = {"myAccountAccountView":"MyAccountAccountView_myAccountAccountView__dElab","rotation":"MyAccountAccountView_rotation__dAU7T"};